import { useTranslation } from 'react-i18next';
import { Link, useLoaderData } from '@tanstack/react-router';
import ServicesCarousel from './services-carousel.tsx';
import SectionTitle from '@/components/layout/section-title.tsx';
import Section from '@/components/layout/section.tsx';

export default function OurServices() {
	const { t } = useTranslation();
	const data = useLoaderData({ from: '__root__' });

	return (
		<Section className="flex flex-col gap-6 max-lg:gap-4">
			<div className="flex items-center justify-between max-md:flex-wrap gap-4">
				<SectionTitle className="text-[var(--primary)]">{t('services.title')}</SectionTitle>

				<Link
					to="/services"
					className="text-[var(--primary)] text-lg max-md:hidden px-4 py-2 bg-[var(--primary-light)] rounded-xl goldman font-medium hover:brightness-95 active:scale-97"
				>
					{t('services.all_service_button_text')}
				</Link>
			</div>

			<ServicesCarousel data={data?.services} />

			<Link
				to="/services"
				className="w-full flex justify-center text-[var(--primary)] text-lg min-md:hidden px-4 py-2 bg-[var(--primary-light)] rounded-xl goldman font-medium hover:brightness-95 active:scale-97"
			>
				{t('services.all_service_button_text')}
			</Link>
		</Section>
	);
}
